import { IconBase, IconComponent } from './BaseIcon';

export const LayerUp: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M28 4v2.59l-4.29-4.3-1.42 1.42L26.59 8H24v2h6V4h-2zm-9 9V2H2v17h11v11h17V13Zm6.29 2L15 25.29v-2.58L22.71 15ZM15 21.29v-2.58L18.71 15h2.58ZM17.29 15 15 17.29V15ZM4 17V4h13v9h-4v4Zm24 11h-2.29L28 25.71Zm0-3.71L24.29 28h-2.58L28 21.71Zm0-4L20.29 28h-2.58L28 17.71Zm0-4L16.29 28H15v-1.29L26.71 15H28Z" />
  </IconBase>
);
